import styled, { css } from 'styled-components';

export const LayoutRoot = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
`;

export const LayoutContent = styled.div<{ $isPanelOpen: boolean }>`
    flex: 1;

    ${({ $isPanelOpen }) =>
        $isPanelOpen &&
        css`
            --desking-card-min-width: 23rem;
        `}
`;

export const LayoutPanel = styled.div<{ $top: number; $offset: number }>`
    position: sticky;
    top: ${({ $top }) => $top}px;
    flex: none;
    margin-left: ${({ $offset }) => $offset}px;
    width: clamp(260px, 25.5vw, 380px);
    height: calc(100vh - ${({ $top }) => $top}px);
`;
